import React from "react";
import { SelectInput, TextInput } from "react-admin";
import { customComponentsTypesOptions } from "../customComponentsTypes";

const getFilters = mode => {
  const filters = [
    <TextInput
      label="Име или адрес"
      source="Query"
      sx={{ marginBottom: "1rem" }}
      resettable={true}
      alwaysOn
    />,
  ];
  if (mode === "component") {
    filters.push(
      <SelectInput
        label="Тип"
        source="Type"
        choices={customComponentsTypesOptions}
        sx={{ marginBottom: "1rem" }}
        resettable={true}
        alwaysOn
      />,
    );
  }
  return filters;
};
export default getFilters;
